<div class="gb-presenter-dialog-templates">
  <div class="gb-dialog-header">
    <h1 translate="PRESENTER.TEMPLATES"></h1>
    <button mat-icon-button mat-dialog-close>
      <gb-icon icon="close"></gb-icon>
    </button>
  </div>

  @if ({ selectedTemplate: selectedTemplate$ | async, slideOptions: slideOptions$ | async }; as obs) {
    <div class="gb-dialog-content">
      <mat-stepper [linear]="true" class="gb-template-stepper" #stepper>
        <mat-step [completed]="!!obs.selectedTemplate?.uuid" [editable]="true">
          <ng-template matStepLabel>{{ 'PRESENTER.APPLY_TEMPLATE.STEP_SELECT_TEMPLATE' | translate }}</ng-template>
          <gb-presenter-templates-list (preview)="previewTemplate($event)"></gb-presenter-templates-list>
        </mat-step>

        <mat-step [completed]="isStepTwoValid()" [editable]="true">
          <ng-template matStepLabel>{{ 'PRESENTER.APPLY_TEMPLATE.STEP_SELECT_TARGET' | translate }}</ng-template>

          <mat-radio-group [formControl]="targetControl" class="target-radio-group">
            <mat-radio-button value="create" class="target-radio-option">
              {{ 'PRESENTER.APPLY_TEMPLATE.CREATE_NEW_SLIDE' | translate }}
            </mat-radio-button>

            @if (targetControl.value === 'create') {
              <gb-form-field
                [control]="newSlideNameControl"
                labelTranslateKey="PROJECTOR.SLIDE_NAME"
                class="target-input"
              ></gb-form-field>
            }

            <mat-radio-button value="existing" class="target-radio-option">
              {{ 'PRESENTER.APPLY_TEMPLATE.SELECT_EXISTING_SLIDE' | translate }}
            </mat-radio-button>

            @if (targetControl.value === 'existing') {
              <mat-form-field class="target-input">
                <mat-label>{{ 'PROJECTOR.SLIDE_NAME' | translate }}</mat-label>
                <mat-select [formControl]="existingSlideUuidControl">
                  @for (slide of obs.slideOptions || []; track slide.uuid) {
                    <mat-option [value]="slide.uuid">{{ slide.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
          </mat-radio-group>
        </mat-step>
      </mat-stepper>
    </div>

    <div class="gb-flex-button-container gb-dialog-actions-container">
      @if (stepper.selectedIndex === 0) {
        <button mat-stroked-button mat-dialog-close translate="CANCEL"></button>
        <button
          mat-flat-button
          (click)="stepper.next()"
          [disabled]="!obs.selectedTemplate?.uuid"
          translate="NEXT"
        ></button>
      } @else {
        <button mat-stroked-button (click)="stepper.previous()" translate="BACK"></button>
        <button
          mat-flat-button
          type="button"
          (click)="apply()"
          [disabled]="!getCanApply(obs.selectedTemplate?.uuid) || (loaded$ | async) === false"
        >
          <gb-button-loader [loaded$]="loaded$">
            <span translate="APPLY"></span>
          </gb-button-loader>
        </button>
      }
    </div>
  }
</div>
